import { useInfiniteQuery } from "@tanstack/react-query";

const { default: apiClient } = require("lib/api-client");

const fetchDesigns = async ({ pageParam = 1, queryKey }) => {
  const [, { setId, sortBy, sortOrder, searchTerm, limit, location }] = queryKey;

  const response = await apiClient.post("/api/v1/stocks/getStockSetById", {
    setId,
    page: pageParam,
    limit,
    sortBy,
    sortOrder,
    searchTerm,
    location,
  });

  if (response.status !== 200) {
    throw new Error("Error fetching categories");
  }

  return {
    stockSetDesigns: response.data.setStyles,
    nextPage: response.data.pagination.page + 1,
    totalPages: response.data.pagination.totalPages,
    totalCount: response.data.totalInSetStyles,
    totalSerachAndFilter: response.data.totalSerachAndFilter,
  };
};

export const useStockSetDesings = ({ setId, sortBy = "Design Date", sortOrder = "asc", searchTerm = "", limit = 10, location = [] }) => {
  return useInfiniteQuery({
    queryKey: [
      "stockSetDesigns",
      {
        setId,
        sortBy,
        sortOrder,
        searchTerm,
        limit,
        location,
      },
    ],

    queryFn: ({ pageParam = 1 }) =>
      fetchDesigns({
        pageParam,
        queryKey: [
          "stockSetDesigns",
          {
            setId,
            sortBy,
            sortOrder,
            searchTerm,
            limit,
            location,
          },
        ],
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage <= lastPage.totalPages) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
